import styled from 'styled-components';

export const Hr = styled.hr`
  border-color: ${({ theme }) => theme.colors['grey-dark']};
  border-width: 2px;
  margin: 0.5rem 0;
`;
